import { render, staticRenderFns } from "./PluginRequest.vue?vue&type=template&id=1e77d0c4&"
import script from "./PluginRequest.vue?vue&type=script&lang=js&"
export * from "./PluginRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports